<template>
  <vs-popup
    title="PRINT ITEM LABEL"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(printLabel)" autocomplete="off">
          <div class="w-full mb-4">
            <ValidationProvider
              vid="best_before_date"
              name="best_before_date"
              rules="required"
              v-slot="{ errors }"
            >
              <small class="label">Best Before Date</small>
              <flat-pickr
                style="display: none"
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="orderItemDetails.best_before_date"
                placeholder="Choose Date"
              />
              <flat-pickr
                placeholder="Choose Date"
                class="w-full"
                v-model="orderItemDetails.best_before_date"
                :config="{ dateFormat: 'd/m/Y' }"
              />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="w-full mb-4">
            <ValidationProvider
              vid="dosage_info"
              name="dosage_info"
              rules=""
              v-slot="{ errors }"
            >
              <small class="label">Max Dosage</small>
              <vs-input class="w-full" v-model="orderItemDetails.dosage_info" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="flex justify-end gap-4">
            <vs-button button="submit" class="mt-2">Print Label</vs-button>
            <vs-button
              @click="open = false"
              class="mt-2"
              type="border"
              color="warning"
              >Cancel</vs-button
            >
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

const CustomerRepository = RepositoryFactory.get("customer");

export default {
  data() {
    return {
      open: false,
      orderItemDetails: {},
      best_before_date: "",
    };
  },
  components: {
    Datepicker,
    flatPickr,
  },
  methods: {
    openPopUp(data) {
      this.orderItemDetails = data;
      this.open = true;
    },
    async printLabel() {
      let routeData = this.$router.resolve({
        name: "sample-orders-item-label-print-view",
        params: { id: this.orderItemDetails.id },
        query: {
          best_before_date: this.orderItemDetails.best_before_date,
          formulation_code: this.orderItemDetails.formulation_code,
          name: this.orderItemDetails.name,
          dosage: this.orderItemDetails.dosage_info,
          classification: this.orderItemDetails.legal_name || '',
        },
      });
      await this.updateFormulation();
      window.open(routeData.href, "_blank");
    },

    async updateFormulation() {
      const isProduction =
        !this.orderItemDetails.formulation_code.includes("DEV-");
      const permissions = isProduction
        ? ["edit-production-formulations"]
        : ["edit-development-formulations"];
      if (!this.$canAny(permissions)) {
        return;
      }
      const payload = {
        dosage_info: this.orderItemDetails.dosage_info,
        best_before_date: this.orderItemDetails.best_before_date,
      };
      await CustomerRepository.updateSampleOrderItemDosageInfo(
        this.orderItemDetails.id,
        payload
      );
    },
  },
};
</script>
